import React, { useMemo, useState, useEffect } from 'react';
import { FoundationsButton } from "../../GenericComponents/button";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../Redux/store';
import { MetadataDrillThruItem, getMetadataDrillThruToolById } from "../../Redux/Admin_Tasks/MDSSlice";
import GenericTableforArrayofObjects from '../../GenericComponents/GenericTableforArrayofObjects';
import { getBaseUrl } from '../../Utils';
import SelectMetadata from './AddEditMetadataDrillThruSet';

const MdsTool: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const [searchMetadataDrillthruSetName, setSearchTerm] = useState<string>('');
    const [isAddingNew, setIsAddingNew] = useState<boolean>(false);
    const [editMetadataDrillthruSet, setEditMetadata] = useState<any>(null);
    const [fetchingData, setFetchingData] = useState<boolean>(false);
    const { items, status, error } = useSelector((state: RootState) => state.items || { items: [], status: 'idle', error: null });

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch(event);
        }
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(MetadataDrillThruItem(searchMetadataDrillthruSetName.trim()));
    };

    const onBackButtonClick = () => {
        setIsAddingNew(false);
        setEditMetadata(null);
    };

    const handleEdit = async (mdsId: number) => {
        setFetchingData(true);
        const response = await dispatch(getMetadataDrillThruToolById(mdsId));
        const fetchedData = response.payload.data;
        setEditMetadata(fetchedData);
        setIsAddingNew(false); // It's not adding, it's editing
        setFetchingData(false);
    };

    const transformedData = useMemo(() => {
        return Array.isArray(items)
            ? items
                .slice()
                .sort((a, b) => (a.Name > b.Name ? 1 : -1))
                .map(item => ({
                    ...item,
                    Action: (
                        <FoundationsButton
                            classes='MDSedit'
                            id={"editmds_" + item.Id}
                            buttonClasses="ui-button app-button"
                            onClick={() => handleEdit(item.Id)}
                        >
                            Edit
                        </FoundationsButton>
                    )
                }))
            : [];
    }, [items]);

    return (
        <>
            {isAddingNew || editMetadataDrillthruSet ? (
                <SelectMetadata
                    onBackButtonClick={onBackButtonClick}
                    editClicked={!!editMetadataDrillthruSet} // true if editing
                    editMetadataDrillthruSet={editMetadataDrillthruSet}
                />
            ) : (
                <div>
                    <div className="float-right margin-top-small">
                        <a id="link_backto_admin_tasks" href={`${getBaseUrl()}/ux/index.html#AdminTasks`}>« Back to Admin Tasks</a>
                    </div>

                    <div className='header'>MetadataDrillThru Configuration</div>
                    <br /><br />

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label htmlFor="search">Search: </label>
                                <input
                                    type="text"
                                    id="search"
                                    name="search"
                                    onKeyDown={handleKeyPress}
                                    onChange={e => setSearchTerm(e.target.value)}
                                />
                                <FoundationsButton
                                    buttonClasses="ui-button ui-corner-all ui-widget app-button"
                                    id="searchbutton"
                                    onClick={handleSearch}
                                >
                                    Search
                                </FoundationsButton>
                            </div>

                            <div style={{ marginLeft: '30px' }}>-or-</div>

                            <FoundationsButton
                                type="button"
                                buttonClasses="ui-button app-button"
                                onClick={() => setIsAddingNew(true)}
                                customStyle={{ marginLeft: '30px' }}
                                id="AddNewMDSConfig"
                            >
                                Add New MDS Config
                            </FoundationsButton>
                        </div>

                        {status.MetadataDrillThruItem === 'loading' && <div>Loading...</div>}
                        {error.MetadataDrillThruItem && <div>Error: {error.MetadataDrillThruItem}</div>}
                        {status.MetadataDrillThruItem === 'succeeded' && Array.isArray(items) && items.length > 0 && (
                            <GenericTableforArrayofObjects items={transformedData} />
                        )}
                        {status.MetadataDrillThruItem === 'succeeded' && Array.isArray(items) && items.length === 0 && (
                            <div>No items found.</div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default MdsTool;
